module.exports = __webpack_public_path__ + "images/mmm-faq-04-desktop.png";